import { Link, useLocation } from "react-router-dom";
import { BrandMark, LangMenu, CurrencyMenu } from "./Navbar";
import DownloadApp from "./DownloadApp";
import { Mail, MessageCircle, Phone, FileText, Shield, RefreshCcw, HelpCircle, Info } from "lucide-react";
import { useLang } from "../context/LangContext";

export default function Footer() {
  const { t } = useLang();
  const { pathname } = useLocation();
  // Home and My Marhine stay app-like: content ends with the page itself, no footer
  if (pathname === "/" || pathname === "/account") return null;
  return (
    <footer data-testid="site-footer" className="border-t border-slate-200 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <BrandMark />
            <p className="mt-4 text-sm text-slate-500 leading-relaxed">{t("cta_sub")}</p>
          </div>
          <div>
            <h4 className="font-heading text-slate-900 font-bold text-sm mb-4">{t("quick_links")}</h4>
            <ul className="space-y-2.5 text-sm text-slate-600">
              <li>
                <Link data-testid="footer-about" to="/about" className="flex items-center gap-2 hover:text-teal-700 transition">
                  <Info className="h-4 w-4 text-teal-600" /> {t("about")}
                </Link>
              </li>
              <li>
                <Link data-testid="footer-terms" to="/legal#terms" className="flex items-center gap-2 hover:text-teal-700 transition">
                  <FileText className="h-4 w-4 text-teal-600" /> {t("terms")}
                </Link>
              </li>
              <li>
                <Link data-testid="footer-privacy" to="/legal#privacy" className="flex items-center gap-2 hover:text-teal-700 transition">
                  <Shield className="h-4 w-4 text-teal-600" /> {t("privacy")}
                </Link>
              </li>
              <li>
                <Link data-testid="footer-refund" to="/legal#refund" className="flex items-center gap-2 hover:text-teal-700 transition">
                  <RefreshCcw className="h-4 w-4 text-teal-600" /> {t("refund_t")}
                </Link>
              </li>
              <li>
                <Link data-testid="footer-help" to="/help" className="flex items-center gap-2 hover:text-teal-700 transition">
                  <HelpCircle className="h-4 w-4 text-teal-600" /> {t("help")}
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-heading text-slate-900 font-bold text-sm mb-4">{t("support")}</h4>
            <ul className="space-y-2.5 text-sm text-slate-600">
              <li>
                <a data-testid="footer-contact" href="mailto:support@simashi01.com" className="flex items-center gap-2 hover:text-teal-700 transition">
                  <Phone className="h-4 w-4 text-teal-600" /> {t("contact")}
                </a>
              </li>
              <li>
                <Link data-testid="footer-messages" to="/account" className="flex items-center gap-2 hover:text-teal-700 transition">
                  <MessageCircle className="h-4 w-4 text-teal-600" /> {t("live_chat_link")}
                </Link>
              </li>
              <li>
                <a data-testid="footer-support-email" href="mailto:support@simashi01.com" className="flex items-center gap-2 hover:text-teal-700 transition">
                  <Mail className="h-4 w-4 text-teal-600" /> {t("email_us")}
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-heading text-slate-900 font-bold text-sm mb-4">{t("sell_col")}</h4>
            <p className="text-sm text-slate-500 leading-relaxed">{t("sell_col_sub")}</p>
            <Link
              data-testid="footer-seller-cta"
              to="/seller"
              className="mt-4 inline-block rounded-full bg-teal-700 px-5 py-2.5 text-xs font-bold text-white hover:bg-teal-800 transition"
            >
              {t("open_dash")}
            </Link>
          </div>
        </div>
        <div className="mt-10">
          <DownloadApp compact />
        </div>
        <div className="mt-10 border-t border-slate-100 pt-6 flex flex-col sm:flex-row gap-4 sm:items-center justify-between">
          <div className="flex items-center gap-2">
            <LangMenu />
            <CurrencyMenu />
            <Link data-testid="footer-cart" to="/cart" className="flex items-center gap-1.5 rounded-full px-3 py-2 text-sm font-semibold text-slate-700 hover:bg-teal-50 hover:text-teal-800 transition">
              {t("nav_cart")}
            </Link>
          </div>
          <div className="text-xs text-slate-400 flex flex-col sm:flex-row gap-2 sm:gap-6">
            <span>© {new Date().getFullYear()} MARHINE.COM. {t("rights")}</span>
            <span>{t("same_account")}</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
